import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { invertColors } from '@/assets/scripts/utils'
import vueVimeoPlayer from 'vue-vimeo-player'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTwitter,
  faYoutube,
  faVimeoV,
  faLinkedin,
  faFacebookSquare,
  faInstagram
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueChatScroll from 'vue-chat-scroll'
const createjs = window.createjs

library.add(
  faTwitter,
  faYoutube,
  faVimeoV,
  faLinkedin,
  faFacebookSquare,
  faInstagram
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(vueVimeoPlayer)
Vue.use(VueChatScroll)
Vue.prototype.createjs = createjs

router.beforeEach((to, from, next) => {
  invertColors(false)
  document.title = `M© — ${to.meta.title || 'María Cerdán'}`
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
